const DEFAULT_EQUIPMENT_DATA = [
  {
    "id": 100,
    "name": "DD Gun #100",
    "kind": "gun",
    "pattern": "1×1",
    "dmg": 2,
    "coef": 125,
    "reload": 3.99,
    "volleyTime": 0,
    "roundsPerSec": 0.25,
    "dpsLight": 0.63,
    "dpsMedium": 0.31,
    "dpsHeavy": 0.13,
    "rangeTrigger": 60,
    "rangeShell": 50,
    "spread": "5° rdm",
    "angle": "360",
    "mods": "Normal | 100/50/20",
    "faction": "UN"
  },
  {
    "id": 101,
    "name": "CL Gun #101",
    "kind": "gun",
    "pattern": "1×3",
    "dmg": 5,
    "coef": 125,
    "reload": 7.98,
    "volleyTime": 0,
    "roundsPerSec": 0.38,
    "dpsLight": 2.35,
    "dpsMedium": 1.76,
    "dpsHeavy": 0.94,
    "rangeTrigger": 65,
    "rangeShell": 55,
    "spread": "14° fan",
    "angle": "120",
    "mods": "Normal | 100/75/40",
    "faction": "UN"
  },
  {
    "id": 102,
    "name": "CA Gun #102",
    "kind": "gun",
    "pattern": "1×2",
    "dmg": 12,
    "coef": 110,
    "reload": 11.97,
    "volleyTime": 0,
    "roundsPerSec": 0.17,
    "dpsLight": 2.21,
    "dpsMedium": 1.98,
    "dpsHeavy": 1.1,
    "rangeTrigger": 120,
    "rangeShell": 50,
    "spread": "15° rdm",
    "angle": "40",
    "mods": "Normal | 100/90/50",
    "faction": "UN"
  },
  {
    "id": 103,
    "name": "BB Gun #103",
    "kind": "gun",
    "pattern": "1×2",
    "dmg": 16,
    "coef": 110,
    "reload": 16.76,
    "volleyTime": 0,
    "roundsPerSec": 0.12,
    "dpsLight": 1.47,
    "dpsMedium": 2.1,
    "dpsHeavy": 1.89,
    "rangeTrigger": 200,
    "rangeShell": 80,
    "spread": "0°",
    "angle": "50",
    "mods": "Normal | 70/100/90",
    "faction": "UN"
  },
  {
    "id": 104,
    "name": "AA Gun #104",
    "kind": "aa",
    "dmg": 4,
    "reload": 0.4,
    "dps": 20.05,
    "range": 20,
    "faction": "UN"
  },
  {
    "id": 105,
    "name": "Torp #105",
    "kind": "torpedo",
    "rounds": "1×2",
    "dmg": 17,
    "coef": 100,
    "reload": 21.75,
    "dpsLight": 1.25,
    "dpsMedium": 1.56,
    "dpsHeavy": 2.03,
    "rangeTrigger": 50,
    "rangeReach": 90,
    "spread": "30° fan",
    "angle": "60",
    "mods": "Torp | 80/100/130",
    "faction": "UN"
  },
  {
    "id": 106,
    "name": "Torp #106",
    "kind": "torpedo",
    "rounds": "1×3",
    "dmg": 17,
    "coef": 100,
    "reload": 26.1,
    "dpsLight": 1.56,
    "dpsMedium": 1.95,
    "dpsHeavy": 2.54,
    "rangeTrigger": 50,
    "rangeReach": 90,
    "spread": "40° fan",
    "angle": "60",
    "mods": "Torp | 80/100/130",
    "faction": "UN"
  },
  {
    "id": 107,
    "name": "Torp #107",
    "kind": "torpedo",
    "rounds": "1×4",
    "dmg": 17,
    "coef": 100,
    "reload": 30.44,
    "dpsLight": 1.79,
    "dpsMedium": 2.23,
    "dpsHeavy": 2.9,
    "rangeTrigger": 50,
    "rangeReach": 90,
    "spread": "48° fan",
    "angle": "60",
    "mods": "Torp | 80/100/130",
    "faction": "UN"
  },
  {
    "id": 108,
    "name": "Torp #108",
    "kind": "torpedo",
    "rounds": "1×5",
    "dmg": 17,
    "coef": 100,
    "reload": 34.79,
    "dpsLight": 1.95,
    "dpsMedium": 2.44,
    "dpsHeavy": 3.18,
    "rangeTrigger": 50,
    "rangeReach": 90,
    "spread": "60° fan",
    "angle": "60",
    "mods": "Torp | 80/100/130",
    "faction": "UN"
  },
  {
    "id": 109,
    "name": "Ftr #109",
    "kind": "aircraft",
    "ordnance": 131,
    "reload": 11.97,
    "faction": "US"
  },
  {
    "id": 110,
    "name": "TB #110",
    "kind": "aircraft",
    "ordnance": 135,
    "reload": 20.71,
    "faction": "US"
  },
  {
    "id": 111,
    "name": "DB #111",
    "kind": "aircraft",
    "ordnance": 139,
    "reload": 23.94,
    "faction": "US"
  },
  {
    "id": 113,
    "name": "Ftr #113",
    "kind": "aircraft",
    "ordnance": 132,
    "reload": 12.64,
    "faction": "UK"
  },
  {
    "id": 114,
    "name": "TB #114",
    "kind": "aircraft",
    "ordnance": 135,
    "reload": 20.71,
    "faction": "UK"
  },
  {
    "id": 115,
    "name": "DB #115",
    "kind": "aircraft",
    "ordnance": 139,
    "reload": 23.94,
    "faction": "UK"
  },
  {
    "id": 117,
    "name": "Ftr #117",
    "kind": "aircraft",
    "ordnance": 133,
    "reload": 10.64,
    "faction": "JP"
  },
  {
    "id": 118,
    "name": "TB #118",
    "kind": "aircraft",
    "ordnance": 135,
    "reload": 23.94,
    "faction": "JP"
  },
  {
    "id": 119,
    "name": "DB #119",
    "kind": "aircraft",
    "ordnance": 139,
    "reload": 23.94,
    "faction": "JP"
  },
  {
    "id": 121,
    "name": "Ftr #121",
    "kind": "aircraft",
    "ordnance": 134,
    "reload": 11.97,
    "faction": "DE"
  },
  {
    "id": 123,
    "name": "DB #123",
    "kind": "aircraft",
    "ordnance": 139,
    "reload": 23.94,
    "faction": "DE"
  },
  {
    "id": 125,
    "name": "Ftr #125",
    "kind": "aircraft",
    "ordnance": 134,
    "reload": 11.97,
    "faction": "FF"
  },
  {
    "id": 126,
    "name": "TB #126",
    "kind": "aircraft",
    "ordnance": 135,
    "reload": 22.94,
    "faction": "FF"
  },
  {
    "id": 127,
    "name": "DB #127",
    "kind": "aircraft",
    "ordnance": 139,
    "reload": 23.94,
    "faction": "FF"
  },
  {
    "id": 140,
    "name": "Torp #140",
    "kind": "torpedo",
    "rounds": "1×1",
    "dmg": 17,
    "coef": 100,
    "reload": 5.65,
    "dpsLight": 2.11,
    "dpsMedium": 3.01,
    "dpsHeavy": 3.61,
    "rangeTrigger": 50,
    "rangeReach": 90,
    "spread": "0°",
    "angle": "75",
    "mods": "Torp | 70/100/120",
    "faction": "UN"
  },
  {
    "id": 141,
    "name": "DC #141",
    "kind": "asw",
    "dmg": 60,
    "reload": 6.32,
    "dps": 18.99,
    "faction": "UN"
  },
  {
    "id": 144,
    "name": "SP #144",
    "kind": "aircraft",
    "ordnance": 145,
    "reload": 18.29,
    "faction": "JP"
  },
  {
    "id": 147,
    "name": "DC #147",
    "kind": "asw",
    "dmg": 60,
    "reload": 6.98,
    "dps": 17.18,
    "faction": "UN"
  },
  {
    "id": 148,
    "name": "Ftr #148",
    "kind": "aircraft",
    "ordnance": 132,
    "reload": 11.97,
    "faction": "IT"
  },
  {
    "id": 149,
    "name": "TB #149",
    "kind": "aircraft",
    "ordnance": 136,
    "reload": 22.94,
    "faction": "IT"
  },
  {
    "id": 150,
    "name": "DB #150",
    "kind": "aircraft",
    "ordnance": 139,
    "reload": 23.94,
    "faction": "IT"
  },
  {
    "id": 152,
    "name": "SP #152",
    "kind": "aircraft",
    "ordnance": 145,
    "reload": 18.29,
    "faction": "JP"
  },
  {
    "id": 153,
    "name": "Ftr #153",
    "kind": "aircraft",
    "ordnance": 134,
    "reload": 11.97,
    "faction": "FF"
  },
  {
    "id": 154,
    "name": "TB #154",
    "kind": "aircraft",
    "ordnance": 135,
    "reload": 22.94,
    "faction": "FF"
  },
  {
    "id": 155,
    "name": "DB #155",
    "kind": "aircraft",
    "ordnance": 139,
    "reload": 23.94,
    "faction": "FF"
  },
  {
    "id": 430,
    "name": "DD Gun #430",
    "kind": "gun",
    "pattern": "2×2",
    "dmg": 21,
    "coef": 100,
    "reload": 2.79,
    "volleyTime": 0.1,
    "roundsPerSec": 1.38,
    "dpsLight": 29.03,
    "dpsMedium": 23.23,
    "dpsHeavy": 17.42,
    "rangeTrigger": 90,
    "rangeShell": 90,
    "spread": "0°",
    "angle": "360",
    "mods": "AP | 100/80/60",
    "faction": "SU"
  },
  {
    "id": 431,
    "name": "DD Gun #431",
    "kind": "gun",
    "pattern": "2×2",
    "dmg": 21,
    "coef": 115,
    "reload": 1.5,
    "volleyTime": 0.1,
    "roundsPerSec": 2.5,
    "dpsLight": 60.26,
    "dpsMedium": 60.26,
    "dpsHeavy": 60.26,
    "rangeTrigger": 90,
    "rangeShell": 90,
    "spread": "0°",
    "angle": "360",
    "mods": "AP | 100/100/100",
    "faction": "DE"
  },
  {
    "id": 432,
    "name": "CL Gun #432",
    "kind": "gun",
    "pattern": "2×3",
    "dmg": 21,
    "coef": 115,
    "reload": 2.74,
    "volleyTime": 0.15,
    "roundsPerSec": 2.08,
    "dpsLight": 50.14,
    "dpsMedium": 50.14,
    "dpsHeavy": 50.14,
    "rangeTrigger": 65,
    "rangeShell": 80,
    "spread": "10° fan",
    "angle": "360",
    "mods": "AP | 100/100/100",
    "faction": "DE"
  },
  {
    "id": 436,
    "name": "CL Gun #436",
    "kind": "gun",
    "pattern": "2×2",
    "dmg": 21,
    "coef": 115,
    "reload": 2.74,
    "volleyTime": 0.1,
    "roundsPerSec": 1.41,
    "dpsLight": 34.01,
    "dpsMedium": 34.01,
    "dpsHeavy": 34.01,
    "rangeTrigger": 90,
    "rangeShell": 80,
    "spread": "0°",
    "angle": "360",
    "mods": "AP | 100/100/100",
    "faction": "DE"
  },
  {
    "id": 437,
    "name": "AA Gun #437",
    "kind": "aa",
    "dmg": 23,
    "reload": 1,
    "dps": 46.11,
    "range": 25,
    "faction": "UK"
  },
  {
    "id": 438,
    "name": "CL Gun #438",
    "kind": "gun",
    "pattern": "2×2",
    "dmg": 23,
    "coef": 100,
    "reload": 2.33,
    "volleyTime": 0.1,
    "roundsPerSec": 1.65,
    "dpsLight": 51.16,
    "dpsMedium": 36,
    "dpsHeavy": 26.53,
    "rangeTrigger": 90,
    "rangeShell": 75,
    "spread": "0°",
    "angle": "360",
    "mods": "HE | 135/95/70",
    "faction": "DE"
  },
  {
    "id": 439,
    "name": "CL Gun #439",
    "kind": "gun",
    "pattern": "2×2",
    "dmg": 15,
    "coef": 100,
    "reload": 2.74,
    "volleyTime": 0.1,
    "roundsPerSec": 1.41,
    "dpsLight": 21.13,
    "dpsMedium": 21.13,
    "dpsHeavy": 21.13,
    "rangeTrigger": 90,
    "rangeShell": 80,
    "spread": "0°",
    "angle": "360",
    "mods": "AP | 100/100/100",
    "faction": "DE"
  },
  {
    "id": 446,
    "name": "DD Gun #446",
    "kind": "gun",
    "pattern": "2×2",
    "dmg": 16,
    "coef": 115,
    "reload": 2.74,
    "volleyTime": 0.1,
    "roundsPerSec": 1.41,
    "dpsLight": 25.91,
    "dpsMedium": 25.91,
    "dpsHeavy": 25.91,
    "rangeTrigger": 105,
    "rangeShell": 110,
    "spread": "0°",
    "angle": "360",
    "mods": "AP | 100/100/100",
    "faction": "DE"
  },
  {
    "id": 447,
    "name": "CL Gun #447",
    "kind": "gun",
    "pattern": "2×2",
    "dmg": 21,
    "coef": 115,
    "reload": 2.74,
    "volleyTime": 0.1,
    "roundsPerSec": 1.41,
    "dpsLight": 34.01,
    "dpsMedium": 34.01,
    "dpsHeavy": 34.01,
    "rangeTrigger": 90,
    "rangeShell": 80,
    "spread": "0°",
    "angle": "360",
    "mods": "AP | 100/100/100",
    "faction": "DE"
  },
  {
    "id": 448,
    "name": "Torp #448",
    "kind": "torpedo",
    "rounds": "1×1",
    "dmg": 17,
    "coef": 100,
    "reload": 21.75,
    "dpsLight": 0.63,
    "dpsMedium": 0.78,
    "dpsHeavy": 1.02,
    "rangeTrigger": 50,
    "rangeReach": 90,
    "spread": "0°",
    "angle": "60",
    "mods": "Torp | 80/100/130",
    "faction": "UN"
  },
  {
    "id": 465,
    "name": "CL Gun #465",
    "kind": "gun",
    "pattern": "2×2",
    "dmg": 15,
    "coef": 100,
    "reload": 2.33,
    "volleyTime": 0.1,
    "roundsPerSec": 1.65,
    "dpsLight": 29.66,
    "dpsMedium": 14.83,
    "dpsHeavy": 14.83,
    "rangeTrigger": 90,
    "rangeShell": 50,
    "spread": "0°",
    "angle": "160",
    "mods": "HE | 120/60/60",
    "faction": "DE"
  },
  {
    "id": 468,
    "name": "Aux #468",
    "kind": "asw",
    "dmg": 153,
    "reload": 3.62,
    "dps": 42.21,
    "faction": "US"
  },
  {
    "id": 470,
    "name": "DC #470",
    "kind": "asw",
    "dmg": 70,
    "reload": 3.59,
    "dps": 58.47,
    "faction": "UN"
  },
  {
    "id": 11250,
    "name": "DD Gun #11250",
    "kind": "gun",
    "pattern": "2×2",
    "dmg": 15,
    "coef": 110,
    "reload": 1.53,
    "volleyTime": 0.1,
    "roundsPerSec": 2.45,
    "dpsLight": 48.6,
    "dpsMedium": 24.3,
    "dpsHeavy": 24.3,
    "rangeTrigger": 60,
    "rangeShell": 50,
    "spread": "0°",
    "angle": "360",
    "mods": "HE | 120/60/60",
    "faction": "US"
  },
  {
    "id": 161480,
    "name": "AA Gun #161480",
    "kind": "aa",
    "dmg": 126,
    "reload": 1.28,
    "dps": 197.35,
    "range": 30,
    "faction": "UK"
  }
];
